import * as React from 'react';
import { Admin, Resource } from 'react-admin';
import NotificationList from './NotificationList'; 
import PopupAdList from './PopupAdList'; 
import Dashboard from './Dashboard';
import dataProvider from './customDataProvider';
import authProvider from './authProvider'; 
import SlidersList from './SlidersList'; 
import ServiceGroupsList from './ServiceGroupsList'; 
import PackageGroups from './PackageGroups'; 
const App = () => (
    <Admin 
        dashboard={Dashboard} 
        dataProvider={dataProvider} 
        authProvider={authProvider}
    >
        <Resource
            name="notifications"
            list={NotificationList} 
        />
        <Resource
            name="popup-ad" 
            list={PopupAdList}
        />
        <Resource 
            name="slider" 
            list={SlidersList} 
        />
        <Resource 
            name="service-groups" 
            list={ServiceGroupsList} 
        />
        <Resource 
            name="package-groups" 
            list={PackageGroups} 
            options={{ label: 'Groups' }} 
        />
    </Admin>
);

export default App;
